import React, { useState, useRef, useEffect, memo } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ToastContainer } from 'react-toastify';
import 'react-simple-keyboard/build/css/index.css'; // Import keyboard styles
import '../css/login.css'
import loginSchema from '../validation/loginSchema';
import { encryptData } from "../utils/encryptDecrypt";
import { useDispatch, useSelector } from 'react-redux';
import { authActions, kioskLoginActions } from '../_store';
import '../css/keyboard.css'
import logo from '../../src/assets/images/inmate-white-logo.png'
import { useNavigate } from 'react-router-dom';
import CustomModal from '../components/common/CustomModal ';
import { KioskDashboardActions } from '../_store/KioskDashboard.slice';
import Button from '../components/common/ui/Button';
import CustomKeyboard from '../components/common/CustomKeyboard';
import useKioskRestrictIntervalValidation from '../hooks/useKioskRestrictIntervalValidation';
import useIPAddress from '../hooks/useIPAddress';
import { getStoredValue, removeStoredValue, getStoredMacIDValue } from "../../src/_helpers/storageHelper";
import { getDeviceInfo } from '../_helpers/deviceInfo';

const Login = () => {
  const [inputs, setInputs] = useState({
    LoginId: '',
    Pin: ''
  });

  const fields = ['LoginId', 'Pin'];
  const placeholder = { LoginId: "Enter ID", Pin: "Enter PIN" }
  const [currentField, setCurrentField] = useState(''); // Keeps track of the current active input
  const [showBoard, setShowBoard] = useState(false); // Controls the visibility of the keyboard
  const [ishandleLogin, setishandleLogin] = useState(false);
  const keyboardRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loginResponse } = useSelector(state => state.kioskLogin);
  const [showPopup, setShowPopup] = useState(false);
  const [modalContent, setmodalContent] = useState("");
  const [errorMessage, setErrorMessage] = useState({});
  const validateKioskRestrictInterval = useKioskRestrictIntervalValidation();
  const storedLoginDetails = getStoredValue("loginDetails");
  const macId = getStoredMacIDValue('KIOKEY') || getStoredMacIDValue('MacId');
  const [isActive, setIsActive] = useState(true);
  const [timeLeft, setTimeLeft] = useState(900); // Set to 10 seconds
  const ip = useIPAddress();
  const [isloading, setisloading] = useState(false);

  useEffect(() => {
    let inactivityTimer;
    const resetTimer = () => {
      setIsActive(true);
      setTimeLeft(900); // Reset timer to 10 seconds
      clearTimeout(inactivityTimer);
      // inactivityTimer = setTimeout(handleLogoutWarning, 5 * 1000); // Show warning after 5 seconds
    };

    window.addEventListener('mousemove', resetTimer);
    window.addEventListener('keydown', resetTimer);
    window.addEventListener('click', resetTimer);

    // inactivityTimer = setTimeout(handleLogoutWarning, 5 * 1000); // Show warning after 5 seconds

    return () => {
      clearTimeout(inactivityTimer);
      window.removeEventListener('mousemove', resetTimer);
      window.removeEventListener('keydown', resetTimer);
      window.removeEventListener('click', resetTimer);
    };

  }, []);

  useEffect(() => {
    if (!isActive || timeLeft <= 0) return;

    const countdownInterval = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime <= 1) {
          clearInterval(countdownInterval);
          setIsActive(false);
          dispatch(authActions.logout()); // Log out when time reaches zero
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(countdownInterval);
  }, [isActive, timeLeft]);

  useEffect(() => {
    if (!macId) {
      navigate('/');
    }
  }, [macId]);

  useEffect(() => {
    if (keyboardRef.current) {
      keyboardRef.current.setInput(inputs[currentField] || "");
    }
  }, [currentField]);

  useEffect(() => {
    // Function to execute on page refresh
    const handlePageRefresh = () => {
      removeStoredValue("inmateMenuList"); removeStoredValue("loginResponse"); removeStoredValue("KioskRestrictIntervalValidate");
      navigate('/');
    };

    // Check if the page has been refreshed
    if (sessionStorage.getItem('isRefreshed')) {
      handlePageRefresh();
    } else {
      sessionStorage.setItem('isRefreshed', 'true');
    }

    return () => {
      sessionStorage.removeItem('isRefreshed');
    };
  }, []);


  // useEffect(() => {
  //   if (ishandleLogin && loginResponse?.IsImateLoginValid) {
  //     const deviceDetails = getDeviceInfo();
  //     const DeviceDetPayload = {
  //       InmateResidentId: inputs.LoginId,
  //       UserPassword: inputs.Pin,
  //       facilityID: storedLoginDetails.FacilityID,
  //       kioskCode: storedLoginDetails.KiosksCode,
  //       podID: storedLoginDetails.PodCode,
  //       deviceType: deviceDetails.deviceType,
  //       browser: deviceDetails.browser,
  //       osName: deviceDetails.os,
  //       userAgent: deviceDetails.userAgent,
  //       inmateId: loginResponse?.InmateID
  //     };
  //     dispatch(kioskLoginActions.PostEloDeviceDetails(DeviceDetPayload)).then((x) => {
  //       setInputs({ LoginId: '', Pin: '' });
  //       switch (loginResponse?.IsImateLoginValid) {
  //         case 1:
  //           navigate(loginResponse.IsSQ === 1 ? '/SecurityQuestion' : '/Dashboard');
  //           if (loginResponse?.IsSQ != 1) { window.location.reload() }
  //           const storedLoginDetails = getStoredValue("loginDetails");
  //           const podCode = storedLoginDetails?.PodCode;
  //           const inmateID = loginResponse?.InmateID;
  //           if (inmateID && podCode)
  //             dispatch(KioskDashboardActions.getLoadInmateMainMenu({ inmateID, podCode }));
  //           break;
  //         case -1:
  //           setmodalContent("Operation Failed.");
  //           setShowPopup(true)
  //           break;
  //         case -2:
  //           setmodalContent("Invalid Inmate ID.")
  //           setShowPopup(true)
  //           break;
  //         case -3:
  //           setmodalContent("Inmate  Released.")
  //           setShowPopup(true)
  //           break;
  //         case -4:
  //           // setmodalContent("Inmate Not Access Any kiosks machine in his facility. Inmate Blocked  to Access Any Kiosks")
  //           setmodalContent("Inmate login disabled.")
  //           setShowPopup(true)
  //           break;
  //         case -5:
  //           setmodalContent("Inmate Not Allowed to access is the Kiosks.");
  //           setShowPopup(true)
  //           break;
  //         case -6:
  //           setmodalContent("Invalid Pin.")
  //           setShowPopup(true)
  //           break;
  //         case -8:
  //           setmodalContent("Facility Lockdown is Active.")
  //           setShowPopup(true)
  //           break;
  //         case -9:
  //           setmodalContent("Facility Kiosk Lockdown is Active.")
  //           setShowPopup(true)
  //           break;
  //         case -10:
  //           setmodalContent("Facility Kiosk Lock is Active.")
  //           setShowPopup(true)
  //           break;
  //         case -11:
  //           setmodalContent("POD is Inactive.")
  //           setShowPopup(true)
  //           break;
  //         case -12:
  //           setmodalContent("Kiosk is Inactive.")
  //           setShowPopup(true)
  //           break;
  //         default:
  //           break;
  //       }
  //     });

  //   }
  // }, [loginResponse, ishandleLogin]);

  const [values, setValues] = useState({}); // Initialize as an empty object

  const handleFieldClick = (field) => {
    let data = inputs ? { LoginId: inputs.LoginId || '', Pin: inputs.Pin || '' } : { LoginId: '', Pin: '' };
    setValues(data)
    setCurrentField(field);
    setShowBoard(true); // Show the keyboard when a field is clicked
  };

  const handleCancel = () => {
    if (values?.LoginId || values?.Pin) {
      setInputs(values);
    } else {
      // Reset LoginId and Pin if no values are available
      setInputs({
        LoginId: "",
        Pin: ""
      });
    }
    setShowBoard(false)
  }

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMessage({});

    const { error } = loginSchema(inputs);
    if (error) {
      error.details.forEach((e) => {
        setErrorMessage((prev) => ({
          ...prev,
          [e.path.toString()]: e.message,
        }));
      });
      return;
    }
    if (inputs.LoginId && inputs.Pin && storedLoginDetails?.FacilityID && storedLoginDetails?.KiosksCode) {
      const encryptPassword = encryptData(inputs.Pin);
      const loginPayload = {
        InmateResidentId: inputs.LoginId,
        UserPassword: inputs.Pin,
        facilityID: storedLoginDetails.FacilityID,
        kiosksCode: storedLoginDetails.KiosksCode,
        IsApplogin: 0
      };
      validateKioskRestrictInterval(storedLoginDetails);
      setisloading(true);
      dispatch(kioskLoginActions.getInmateLoginValidate(loginPayload)).then((x) => {
        const result = x?.payload;
        if (result?.IsImateLoginValid) {
          const deviceDetails = getDeviceInfo();
          const DeviceDetPayload = {
            InmateResidentId: inputs.LoginId,
            UserPassword: inputs.Pin,
            facilityID: storedLoginDetails.FacilityID,
            kioskCode: storedLoginDetails.KiosksCode,
            podID: storedLoginDetails.PodCode,
            deviceType: deviceDetails.deviceType,
            browser: deviceDetails.browser,
            osName: deviceDetails.os,
            userAgent: deviceDetails.userAgent,
            inmateId: result?.InmateID
          };
          dispatch(kioskLoginActions.PostEloDeviceDetails(DeviceDetPayload)).then((x) => {
            setInputs({ LoginId: '', Pin: '' });
            setisloading(false);
            setishandleLogin(true);
            switch (result?.IsImateLoginValid) {
              case 1:
                navigate(result.IsSQ === 1 ? '/SecurityQuestion' : '/Dashboard');
                if (result?.IsSQ != 1) { window.location.reload() }
                const storedLoginDetails = getStoredValue("loginDetails");
                const podCode = storedLoginDetails?.PodCode;
                const inmateID = result?.InmateID;
                if (inmateID && podCode)
                  dispatch(KioskDashboardActions.getLoadInmateMainMenu({ inmateID, podCode }));
                break;
              case -1:
                setmodalContent("Operation Failed.");
                setShowPopup(true)
                break;
              case -2:
                setmodalContent("Invalid Inmate ID.")
                setShowPopup(true)
                break;
              case -3:
                setmodalContent("Inmate  Released.")
                setShowPopup(true)
                break;
              case -4:
                // setmodalContent("Inmate Not Access Any kiosks machine in his facility. Inmate Blocked  to Access Any Kiosks")
                setmodalContent("Inmate login disabled.")
                setShowPopup(true)
                break;
              case -5:
                setmodalContent("Inmate Not Allowed to access this Kiosk.");
                setShowPopup(true)
                break;
              case -6:
                setmodalContent("Invalid Pin.")
                setShowPopup(true)
                break;
              case -8:
                setmodalContent("Facility Lockdown is Active.")
                setShowPopup(true)
                break;
              case -9:
                setmodalContent("Facility Kiosk Lockdown is Active.")
                setShowPopup(true)
                break;
              case -10:
                setmodalContent("Facility Kiosk Lock is Active.")
                setShowPopup(true)
                break;
              case -11:
                setmodalContent("POD is Inactive.")
                setShowPopup(true)
                break;
              case -12:
                setmodalContent("Kiosk is Inactive.")
                setShowPopup(true)
                break;
              default:
                setisloading(false);
                setishandleLogin(true);
                break;
            }
          });
        }

      });
      setishandleLogin(true);
    }
  };

  return (
    <div id="app" className="app bg-light d-flex flex-column justify-content-center align-items-center">
      {/* Background Image */}
      <div className="position-absolute top-0 start-0 w-100 h-100 login-bg">
        <div className="login-bg-overlay"></div>
      </div>

      {/* Logo Image */}
      <div className="login-screen-top">


        {!showBoard && (
          <>
            <img src={logo} onClick={() => { navigate('/'); validateKioskRestrictInterval(storedLoginDetails) }} alt="Logo" className="mb-4 inmate-logo-login" />

            <div className="login-card d-flex  flex-column justify-content-center align-items-center p-8 shadow-lg">
              <h2 className="text-center kiosk-title">Login</h2>
              <div className="w-100">
                <div className="">
                  <label
                    htmlFor="LoginId"
                    className="d-flex align-items-center font-size-15 fw-600"
                  >
                    Enter ID
                  </label>
                  <input
                    type="text"
                    className={`form-control mb-5px fs-5 ${errorMessage["LoginId"] ? "input-error" : ""}`}
                    id="LoginId"
                    placeholder="Enter ID"
                    name="LoginId"
                    autoComplete="off"
                    value={inputs.LoginId}
                    onClick={() => handleFieldClick('LoginId')}
                  />
                  <div className="text-danger-new  mb-20px mt-1">
                    {errorMessage["LoginId"] && errorMessage["LoginId"]}
                  </div>

                  <div className="">
                    <label
                      htmlFor="Pin"
                      className="d-flex align-items-center font-size-15 fw-600"
                    >
                      Enter PIN
                    </label>
                    <input
                      type="text"
                      className={`form-control mb-5px fs-5 ${errorMessage["Pin"] ? "input-error" : ""}`}
                      id="Pin"
                      placeholder="Enter PIN"
                      name="Pin"
                      value={inputs.Pin}
                      onClick={() => handleFieldClick('Pin')}
                      autoComplete="off"
                      style={{ WebkitTextSecurity: "disc" }} // mimic password dots
                    />
                    <div className="text-danger-new  mb-20px mt-1">
                      {errorMessage["Pin"] && errorMessage["Pin"]}
                    </div>

                    <div className="d-flex justify-content-center">
                      <Button
                        variant="primary"
                        className="me-2"
                        onClick={handleLogin}
                        label="LOGIN"
                        type="button"
                        status="primary"
                        isLoading={isloading ? true : false}
                        disabled={isloading ? true : false}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </>
        )}
      </div>
      {showPopup && <CustomModal
        color={'#c8605e'}
        content={modalContent} onOkClick={() => { setShowPopup(false) }} />}
      {/* Virtual Keyboard */}
      {showBoard && (
        <div className="p-4">
          <CustomKeyboard
            currentField={currentField}
            setCurrentField={setCurrentField}
            inputs={inputs}
            setShowBoard={setShowBoard}
            handleCancel={handleCancel}
            setInputs={setInputs}
            fields={fields}
            setErrorMessage={setErrorMessage}
            type="Multiple"
            setValues={setValues}
            placeholderList={placeholder}
            fromKioskSetup={true}
          />
        </div>
      )}
      <ToastContainer />
    </div>
  );
};

export default memo(Login);


